import request from '../../utils/request'
const getConfirm = (tmpl) => {
    return request({
        url: process.env.VUE_APP_API +  `particulars/confirm/insurance/${tmpl}`,
        method: 'get',
    })
}

export {
  getConfirm
}